import styles from './charts.module.scss'

// POC: dependency-free horizontal grouped bars.
const HorizontalBars = ({ rows }) => {
  const maxValue = Math.max(...rows.flatMap(r => r.values.map(v => v.value)), 0)
  if (rows.length === 0) return null

  return (
    <div className={styles.bars_wrapper}>
      {rows.map(row => (
        <div key={row.label} className={styles.bar_row}>
          <span className={styles.bar_label}>
            {row.label}
            {row.totals && (
              <span className={styles.bar_totals}>
                <span style={{ color: '#faad14' }}>{row.totals.open} abiertos</span>
                <span style={{ color: '#52c41a', marginLeft: 8 }}>{row.totals.closed} cerrados</span>
              </span>
            )}
          </span>
          <div className={styles.bar_tracks}>
            {row.values.map(value => (
              <div key={value.key} className={styles.bar_track}>
                <div
                  data-test='bar'
                  className={styles.bar_fill}
                  style={{
                    width: maxValue > 0 ? `${(value.value / maxValue) * 100}%` : '0%',
                    backgroundColor: value.color
                  }}
                />
                <span className={styles.bar_value}>{value.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className={styles.legend}>
        {[...new Map(rows.flatMap(r => r.values).map(v => [v.label, v])).values()].map(v => (
          <span key={v.label} className={styles.legend_item}>
            <span className={styles.legend_swatch} style={{ backgroundColor: v.color }} />
            {v.label}
          </span>
        ))}
      </div>
    </div>
  )
}

export default HorizontalBars
